module.exports = __webpack_public_path__ + "static/me-de5170b987c1571e139bdeb02ebcab2d.jpg";